module.exports = __webpack_public_path__ + "img/streamingevents.751070c6.svg";